export default __webpack_public_path__ + "static/media/crates2.4165027b.png";